import React from 'react';

import { CissAutoComplete, CissAutoCompleteProps } from './CissAutoComplete';

interface SituacaoPedidoTotalizadorProps {
    idStatusPedidoTotalizador: number;
    dsStatusPedidoTotalizador: string;
}

type SituacaoPedidoTotalizadorAutoCompleteProps = Pick<CissAutoCompleteProps, 'value' | 'error' | 'multiple' | 'disabled' | 'sx' | 'onChange'>;

export function SituacaoPedidoTotalizadorAutoComplete({
    value,
    error,
    multiple = true,
    disabled = false,
    sx,
    onChange = () => {},
}: SituacaoPedidoTotalizadorAutoCompleteProps) {
    return (
        <CissAutoComplete
            label="Situação da Quebra"
            value={value}
            multiple={multiple}
            error={error}
            selectedStringTemplate="{dsStatusPedidoTotalizador}"
            optionStringTemplate="{dsStatusPedidoTotalizador}"
            requestOptions={{
                url: '/compra/statuspedidototalizador',
                sort: [{ property: 'idStatusPedidoTotalizador', direction: 'ASC' }],
            }}
            isOptionEqualToValue={(option: SituacaoPedidoTotalizadorProps, value: SituacaoPedidoTotalizadorProps) =>
                option.idStatusPedidoTotalizador === value.idStatusPedidoTotalizador
            }
            onChange={onChange}
            disabled={disabled}
            sx={sx}
        />
    );
}
